import { apiFetch, HttpError } from "~/api-fetch/apiFetch";
import { WolfkrowUser } from "~/Auth/WolfkrowUser";
import { useDownloadFile } from "~/file-loading/useDownloadFile";

type DownloadInvoicePdfArgs = {
  url: string;
  filename: string;
  token: string | null;
  user: Pick<WolfkrowUser, "isImpersonating" | "email">;
  download: ReturnType<typeof useDownloadFile>;
  setPdfLoading: (loading: boolean) => void;
};

export async function downloadInvoicePdf({
  url,
  filename,
  token,
  user,
  download,
  setPdfLoading,
}: DownloadInvoicePdfArgs): Promise<void> {
  let res: Response;
  try {
    res = await apiFetch(
      url,
      {
        method: "get",
        headers: {
          "Content-Type": "application/pdf",
          Authorization: token ? `Bearer ${token}` : "",
          impersonation: user.isImpersonating ? user.email : "",
        },
      },
      { operation: "downloadInvoicePdf" }
    );
  } finally {
    // Also on a network failure, so the loading indicator does not spin forever.
    setPdfLoading(false);
  }

  if (res.status === 200) {
    const blob = await res.blob();
    const file = new Blob([blob], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);
    download({ linkHref: fileURL, filename });
  } else {
    throw HttpError.fromResponse(
      res,
      "There was a problem downloading the file"
    );
  }
}
